import { SEND_SOURCE_LABELS, SEND_SOURCE_NONE, SEND_SOURCE_OPTIONS } from '../../utils/formatSendSource';

export const SOURCE_SCOPE_OPTIONS = [...SEND_SOURCE_OPTIONS, { value: SEND_SOURCE_NONE, label: 'Not recorded' }];

export const sourceScopeLabel = (value) => (value === SEND_SOURCE_NONE ? 'Not recorded' : SEND_SOURCE_LABELS[value] || value);

const sourceValues = (scope) => {
    const v = scope?.source;
    if (v == null) return null;
    const arr = Array.isArray(v) ? v : [v];
    return arr.length ? arr : null;
};

export const hasSourceScope = (scope) => !!sourceValues(scope);

export function matchesSendSource(row, scope) {
    const values = sourceValues(scope);
    if (!values) return true;
    return row.sourceType ? values.includes(row.sourceType) : values.includes(SEND_SOURCE_NONE);
}
